import { AxiosError } from 'axios';
import { FieldError } from 'react-hook-form';

export function extractErrorMessage(
  error: Error | AxiosError | FieldError | undefined,
): string | undefined {
  return (error as AxiosError)?.isAxiosError
    ? (error as AxiosError<{ message: string }>).response?.data?.message || error?.message
    : error?.message;
}
